import { CSSProperties, FC } from 'react';
import { TbGrain, TbGridDots } from 'react-icons/tb';

import DropdownButtonSelect, {
    type DropdownButtonOption,
} from '@/shared/components/dropdowns/DropdownButton/DropdownButtonSelect';
import { DropdownMenuLabel } from '@/shared/components/dropdowns/DropdownPanel';
import LearnMoreFooter from '@/shared/components/layouts/footers/LearnMoreFooter';

import type { SearchFilterJoin } from '../searchFilters';

interface FilterMatchingPatternSelectProps {
    onChange: (value: SearchFilterJoin) => void;
    style?: CSSProperties;
    value: SearchFilterJoin;
}

const options: Array<DropdownButtonOption<SearchFilterJoin>> = [
    {
        description: 'Return results matching at least one applied filter.',
        icon: <TbGrain size='1rem' />,
        label: 'Any Filter',
        value: 'any',
    },
    {
        description: 'Return only results matching every applied filter.',
        icon: <TbGridDots size='1rem' />,
        label: 'All Filters',
        value: 'all',
    },
];

const FilterMatchingPatternSelect: FC<FilterMatchingPatternSelectProps> = ({ onChange, style, value }) => (
    <DropdownButtonSelect<SearchFilterJoin>
        aria-label='Filter matching pattern'
        footer={<LearnMoreFooter topic='filter patterns' variant='dropdown' />}
        header={<DropdownMenuLabel>Matching Filters to...</DropdownMenuLabel>}
        matchTriggerWidth={false}
        menuWidth='18rem'
        options={options}
        placement='bottomRight'
        renderValue={(option) => <small>Match {option?.value === 'all' ? 'All' : 'Any'}</small>}
        size='small'
        style={style}
        value={value}
        onChange={(nextValue) => {
            if (nextValue) {
                onChange(nextValue);
            }
        }}
    />
);

export default FilterMatchingPatternSelect;
